import React, { useMemo } from 'react';
import { useMediaQuery } from '@material-ui/core';
import { useAITTheme, type AITTheme } from '@this/shared/ui/theme';

interface Props {
  isActive: boolean;
  isBallon: boolean;
}

const DashboardButton: React.FC<Props> = ({ isActive, isBallon, children }) => {
  const { theme } = useAITTheme();
  const isStackedLayout = useMediaQuery('(max-width: 1030px)');
  const isMobile = useMediaQuery('(max-width: 430px)');
  const styles = useMemo(
    () => getStyles(theme, isStackedLayout, isMobile, isActive),
    [theme, isStackedLayout, isMobile, isActive]
  );

  return (
    <div style={styles.balloon}>
      {children}
      {isBallon && <div style={styles.balloonTail} />}
    </div>
  );
};

function getStyles(theme: AITTheme, isStackedLayout: boolean, isMobile: boolean, isActive: boolean) {
  const backgroundColor = isActive ? theme.accentColor : '#f7f7f7';
  const color = isActive ? '#fff' : theme.accentColor;

  return {
    balloon: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 249,
      height: 64,
      backgroundColor,
      color,
      ...(isStackedLayout && { fontSize: 'min(3vw, 12px)', fontWeight: 700 })
    } as const,
    balloonTail: {
      position: 'absolute',
      top: '100%',
      left: '50%',
      marginLeft: isMobile ? -8 : -15,
      ...(isMobile && { marginTop: -1 }),
      width: 0,
      height: 0,
      borderLeft: `${isMobile ? 8 : 15}px solid transparent`,
      borderRight: `${isMobile ? 8 : 15}px solid transparent`,
      borderTop: `${isMobile ? 8 : 15}px solid ${backgroundColor}`,
      ...(isMobile && { transform: 'translateZ(0)' })
    } as const
  };
}

export default DashboardButton;
